import { Component, DestroyRef, inject, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MatSidenav } from "@angular/material/sidenav";
import { Observable } from "rxjs";
import { debounceTime, distinctUntilChanged, startWith } from "rxjs/operators";
import { LorenNavService } from "../../services/loren-nav-service/loren-nav.service";
import { ActivatedRoute, Router } from "@angular/router";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormControl } from "@angular/forms";

@Component({
  selector: "loren-toolbar",
  templateUrl: "./loren-toolbar.component.html",
  styleUrls: ["./loren-toolbar.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LorenToolbarComponent implements OnInit {
  private router = inject(Router);
  private lorenNavService = inject(LorenNavService);
  private activatedRoute = inject(ActivatedRoute);

  private readonly destroyRef = inject(DestroyRef);

  @Input() drawer: MatSidenav;
  @Input() isHandset: boolean;
  @Input() isTablet: boolean;

  isInAdminApp$: Observable<boolean> = this.lorenNavService.inAdminApp$;
  protected searchTerm = new FormControl('', []);
  protected searchTerm$ = this.searchTerm.valueChanges.pipe(
    startWith(this.searchTerm.value)
  );

  ngOnInit() {
    this.activatedRoute.url
      .pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe(() => {
      const currentUrl = this.router.url;
      if (!currentUrl.includes('/dashboard') && !currentUrl.includes('/assets-list')) {
        this.clearSearch();
      }
    });

    this.activatedRoute.queryParams
      .pipe(
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((params) => {
        if (params.filterBy) {
          this.searchTerm.setValue(params.filterBy);
        }
      });

    this.searchTerm$
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe((value) => {
        const currentUrl = this.router.url;
        const isOnDashboard = currentUrl.includes('/dashboard');
        const isOnAssetsList = currentUrl.includes('/assets-list');

        if (isOnDashboard || isOnAssetsList) {
          this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: { filterBy: value || null },
            queryParamsHandling: 'merge'
          });
        }
      });
  }

  clearSearch() {
    this.searchTerm.setValue('');
  }
}
